import { useEffect, useState, useRef } from 'react'

export default function useScrollSpy(ids, rootMargin = '-40% 0px -55% 0px') {
  const [active, setActive] = useState('')
  const idsRef = useRef(ids)
  idsRef.current = ids

  const idsKey = ids.join(',')

  useEffect(() => {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id)
        })
      },
      { rootMargin }
    )

    idsRef.current.forEach((id) => {
      const el = document.getElementById(id)
      if (el) observer.observe(el)
    })

    return () => observer.disconnect()
  }, [idsKey, rootMargin])

  return active
}
